import { render, staticRenderFns } from "./roleplay.vue?vue&type=template&id=f0e256de&scoped=true&"
import script from "./roleplay.vue?vue&type=script&lang=ts&"
export * from "./roleplay.vue?vue&type=script&lang=ts&"
import style0 from "./roleplay.vue?vue&type=style&index=0&id=f0e256de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e256de",
  null
  
)

export default component.exports